import React from "react";
import { useLocation } from "react-router-dom";
import { FiCheckCircle, FiXCircle, FiClock } from "react-icons/fi"; // <-- Added FiClock for pending
import "./SuccessScreen.css";
import NavUser from "../components/NavUser";

const SuccessScreen = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get("status");
  const message = queryParams.get("message");

  const isSuccess = status === "success";
  const isPending = status === "pending"; // <-- New condition for pending status

  // Determine the CSS class based on status
  let statusClass = "failed";
  if (isSuccess) {
    statusClass = "success";
  } else if (isPending) {
    statusClass = "pending"; // <-- Assign 'pending' class
  }

  // Determine the title text
  let titleText = "Failed!";
  if (isSuccess) {
    titleText = "Success!";
  } else if (isPending) {
    titleText = "Pending..."; // <-- Title for pending status
  }

  return (
    <div className={`success-screen ${statusClass}`}>
      <NavUser />
      <div className="icon-container">
        {isSuccess ? (
          // Success Icon
          <FiCheckCircle className="icon" />
        ) : isPending ? (
          // Pending Icon
          <FiClock className="icon" />
        ) : (
          // Failure Icon (Default/Else)
          <FiXCircle className="icon" />
        )}
      </div>
      <h1>{titleText}</h1>
      <p>{message}</p>
    </div>
  );
};

export default SuccessScreen;
